/**
 * PatientProfile V3 Configuration
 *
 * Feature flags and configuration for the V3 patient profile
 */

// Feature Flags
export const V3_CONFIG = {
  /**
   * Toggle between mock data and real backend data
   * - true: Use hardcoded mock data (for development/testing)
   * - false: Use real data from backend APIs
   */
  USE_MOCK_DATA: false,

  /**
   * Static patient ID for testing (set to null to use dynamic routing)
   */
  STATIC_PATIENT_ID: 488737,

  /**
   * Enable AI features (summary generation, etc.)
   */
  ENABLE_AI_FEATURES: false,

  /**
   * Enable sleep quality tracking
   */
  ENABLE_SLEEP_TRACKING: true,

  /**
   * Default time range for vital charts
   */
  DEFAULT_TIME_RANGE: "1D" as const,
};

// Type definitions
export type TimeRange = "1D" | "7D" | "30D" | "6M";
export type VitalType = "respiratory" | "heartRate" | "sleep";

// Color configuration matching V3 design
export const VITAL_COLORS = {
  respiratory: "#59B7FF",
  heartRate: "#F98E46",
  sleep: "#A768FF",
};

// Chart configuration
export const CHART_CONFIG = {
  respiratory: {
    title: "Respiratory Rate",
    unit: "breaths/min",
    color: VITAL_COLORS.respiratory,
    minValue: 0,
    maxValue: 40,
  },
  heartRate: {
    title: "Heart Rate",
    unit: "bpm",
    color: VITAL_COLORS.heartRate,
    minValue: 40,
    maxValue: 120,
  },
  sleep: {
    title: "Sleep Quality",
    unit: "%",
    color: VITAL_COLORS.sleep,
    minValue: 0,
    maxValue: 100,
  },
};
